import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import logo from '../../../Components/home/images/logo.png';
import coupleImage from '../../../assets/images/couples/Vector.png';
import { SignupContext } from '../../../context/SignupContext';

const CreateProfile = () => {
    // Form data state


    const navigate = useNavigate();
    const { userName, APIformData, userId, isLoggedIn } = useContext(SignupContext);

    const [formData, setFormData] = useState({
        description: `Hello, I am ${userName ? userName : "Hindu Sanjogian"}. Welcome to my profile. I am ${APIformData.age} years old. My height is ${APIformData.height} Ft. This profile is created by ${APIformData.profileFor}. My mother tongue is ${APIformData.language}. I belong to a ${APIformData.family_type}. I am a ${APIformData.highest_education} and ${APIformData.occupation} by Profession. My hobbies are ${APIformData?.hobbies?.map((val, i) => ((i == 0) ? (val) : (` ${val}`)))}. If you like my profile let's connect further on HinduSanjog. Thank you...`,
        subcaste: "",
        currentlocation: (APIformData.country) ? { label: (APIformData.country.label), value: (APIformData.country.value) } : { label: "India", value: "101" },
        country: (APIformData.country) ? { label: (APIformData.country.label), value: (APIformData.country.value) } : { label: "India", value: "101" },
        manglik: "",
        maritalStatus: "",
        height: APIformData.height ? { label: `${APIformData.height} Ft`, value: `${APIformData.height}` } : "",
        weight: "",
        bodyType: "",
        physicalStatus: "",
        eatingHabits: "",
        drinkingHabits: "",
        smokingHabits: "",
        hobbies: (APIformData.hobbies) ? APIformData?.hobbies?.map(sel => ({ label: sel, value: sel })) : "",
        highestEducation: APIformData.highest_education ? {
            label: APIformData.highest_education,
            value: APIformData.highest_education
        } : "",
        educationQualification: "",
        occupation: APIformData.occupation ? { label: APIformData.occupation, value: APIformData.occupation } : "",
        employedIn: "",
        annualIncome: "",
        organizationName: "",
        caste: null,
        sisters: "",
        brothers: "",
        gothra: null,
        maternalGothra: null,
        familyStatus: "",
        familyType: APIformData.family_type ? { label: APIformData.family_type, value: APIformData.family_type } : "",
        familyBelongsTo: "",
        livingWithParents: "",
        state: (APIformData.state) ? { label: (APIformData.state.label), value: (APIformData.state.value) } : "",
        city: null,
        pincode: ""
    });
    // Options data state
    const [options, setOptions] = useState({
        caste: [],
        gothra: [],
        cities: [],
        countries: [],
        income: [],
        language: [],
        states: [],
        education: [],
        occupation: []
    });

    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    // Fetch all dropdown options


    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/sign-up");
        }

        const fetchOptions = async () => {
            try {
                setIsLoading(true);
                setErrors({});

                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
                );

                const resp = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/education.php`
                );

                if (resp.data.data.education) {
                    setOptions({ education: resp.data.data.education });
                } else {
                    setOptions({ education: [] });
                }

                if (!response.data.success) {
                    throw new Error(response.data.error || "Failed to fetch options");
                }


                // Transform all options to ensure they're arrays
                const transformedOptions = {
                    caste: Array.isArray(response.data.data.caste) ? response.data.data.caste : [],
                    gothra: Array.isArray(response.data.data.gothra) ? response.data.data.gothra : [],
                    cities: Array.isArray(response.data.data.cities) ? response.data.data.cities : [],
                    countries: Array.isArray(response.data.data.countries) ? response.data.data.countries : [],
                    income: Array.isArray(response.data.data.income) ? response.data.data.income : [],
                    language: Array.isArray(response.data.data.message) ? response.data.data.message : [],
                    states: Array.isArray(response.data.data.states) ? response.data.data.states : [],
                    subCaste: Array.isArray(response.data.data.subcaste) ? response.data.data.subcaste : [],
                    education: Array.isArray(resp.data.data.education) ? resp.data.data.education : [],
                    occupation: Array.isArray(resp.data.data.occupation) ? resp.data.data.occupation : []
                };

                setOptions(transformedOptions);
            } catch (err) {
                console.error("Error fetching options:", err);
                setErrors(err.message);
                // Initialize with empty arrays if request fails
                setOptions({
                    caste: [],
                    gothra: [],
                    cities: [],
                    countries: [],
                    income: [],
                    language: [],
                    states: [],
                    subCaste: [],
                    education: [],
                    occupation: []
                });
            } finally {
                setIsLoading(false);
            }
        };

        fetchOptions();
    }, []);


    // Handle country changes
    const handlecountryChange = async (name, selectedOption) => {
        setIsLoading(true);
        const resp = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/state.php?country=${selectedOption.value}`
        );
        setOptions(prev => ({
            ...prev,
            states: Array.isArray(resp.data.data.states) ? resp.data.data.states : [],
        }));
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption,
            state: ""
        }));
        setIsLoading(false);
    };

    // Handle country changes
    const handleStateChange = async (name, selectedOption) => {
        setIsLoading(true);
        const resp = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/city.php?state=${selectedOption.value}`
        );
        setOptions(prev => ({
            ...prev,
            cities: Array.isArray(resp.data) ? resp.data : [],
        }));
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption,
            city: ""
        }));
        setIsLoading(false);
    };


    const ChangeDesc = () => {
        setFormData(prev => ({
            ...prev,
            description: `Hello, I am ${userName ? userName : "Hindu Sanjogian"}. Welcome to my profile. I am ${APIformData.age} years old. My height is ${(formData.height.value) ? formData.height.value : APIformData.height} Ft. This profile is created by ${APIformData.profileFor}. My mother tongue is ${APIformData.language}. I belong to a ${(formData.familyType.value) ? formData.familyType.value : APIformData.family_type}. I am a ${(formData.highestEducation.value) ? formData.highestEducation.value : APIformData.highest_education} and ${(formData.occupation.value) ? formData.occupation.value : APIformData.occupation} by Profession. My hobbies are ${((Array.isArray(formData.hobbies))) ? formData.hobbies.map((val, i) => ((i == 0) ? (val.value) : (` ${val.value}`))) : APIformData?.hobbies?.map((val, i) => ((i == 0) ? (val) : (` ${val}`)))}. If you like my profile let's connect further on HinduSanjog. Thank you...`,

        }));
    };


    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));


        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }

        ChangeDesc();

    };


    // Handle select changes
    const handleSelectChange = (name, selectedOption) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption
        }));
        ChangeDesc();
    };

    const validateForm = () => {
        /////after Fill Validate form
        const newErrors = {};

        if (!formData.description.trim()) newErrors.description = "Description is Required";
        if (!formData.subcaste) newErrors.subcaste = "Sub Caste Is Required";
        if (!formData.currentlocation) newErrors.currentlocation = "Please Select Current location";
        if (!formData.manglik) newErrors.manglik = "Manglik is Required";
        if (!formData.maritalStatus) newErrors.maritalStatus = "Martial Status is Required";
        if (!formData.height) newErrors.height = "Height is Required";
        if (!formData.weight) newErrors.weight = "Weight is Required";
        if (!formData.bodyType) newErrors.bodyType = "Body Type is Required";
        if (!formData.physicalStatus) newErrors.physicalStatus = "Physical Status is Required";
        if (!formData.eatingHabits) newErrors.eatingHabits = "Eating Habits is Required";
        if (!formData.drinkingHabits) newErrors.drinkingHabits = "Drinking Habits is Required";
        if (!formData.smokingHabits) newErrors.smokingHabits = "Somking is Required";
        if (formData.hobbies.length < 1) newErrors.hobbies = "Hobbies are Required";
        if (!formData.highestEducation) newErrors.highestEducation = "Highest Education is Required";
        if (!formData.educationQualification) newErrors.educationQualification = "Education Qualification is Required";
        if (!formData.occupation) newErrors.occupation = "Occupation is Required";
        if (!formData.employedIn) newErrors.employedIn = "Employed In is Required";
        if (!formData.annualIncome) newErrors.annualIncome = "Annual Income is Required";
        if (!formData.sisters) newErrors.sisters = "Sister(s) is Required";
        if (!formData.brothers) newErrors.brothers = "Brother(s) is Required";
        if (!formData.gothra) newErrors.gothra = "Gothra is Required";
        if (!formData.maternalGothra) newErrors.maternalGothra = "Maternal Gothra is Required";
        if (!formData.familyStatus) newErrors.familyStatus = "Family Status is Required";
        if (!formData.familyBelongsTo) newErrors.familyBelongsTo = "Family Belongs To is Required";
        if (!formData.familyType) newErrors.familyType = "Familty Type is Required";
        if (!formData.livingWithParents) newErrors.livingWithParents = "Living With is Required";
        if (!formData.country) newErrors.country = "Country is Required";
        if (!formData.state) newErrors.state = "State is Required";
        if (!formData.city) newErrors.city = "City is Required";
        if (!formData.pincode) newErrors.pincode = "Pin Code is Required";


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const payload = new FormData();
            payload.append('user_id', userId);
            payload.append('desc', formData.description);
            payload.append('sub_caste', formData.subcaste.value);
            payload.append('ms', formData.maritalStatus.value);
            payload.append('height', formData.height.value);
            payload.append('weight', formData.weight.value);
            payload.append('body', formData.bodyType.value);
            payload.append('ps', formData.physicalStatus.value);
            payload.append('eating', formData.eatingHabits.value);
            payload.append('drinking', formData.drinkingHabits.value);
            payload.append('smoking', formData.smokingHabits.value);
            payload.append('hobbies', Object.values(formData.hobbies.map(val => (val.value))));
            payload.append('curr_location', formData.currentlocation.label);


            // ///other table
            payload.append('city', formData.city.value);
            payload.append('country', formData.country.label);
            payload.append('state', formData.state.label);
            payload.append('pin', formData.pincode);

            // ///other Table
            payload.append("highest_edu", formData.highestEducation.value);
            payload.append("ug_degree", formData.educationQualification.value);
            payload.append("emp_in", formData.employedIn.value);
            payload.append("occupation", formData.occupation.value);
            payload.append("org_name", formData.organizationName ? formData.organizationName : "");
            payload.append("annual_income", formData.annualIncome.value);

            // ///other Table
            payload.append("sister", formData.sisters.value);
            payload.append("brother", formData.brothers.value);
            payload.append("gothra", formData.gothra.value);
            payload.append("gothra_maternal", formData.maternalGothra.value);
            payload.append("family_status", formData.familyStatus.value);
            payload.append("family_type", formData.familyType.value);
            payload.append("family_based", formData.familyBelongsTo.label);
            payload.append("living_wth_parents", formData.livingWithParents.value);
            payload.append("manglik", formData.manglik.value);


            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/Register_controller/upload_reg`,
                payload
            );

          

            if (response.data.status) {
                ///use context api
                // setUserId(response.data.id);
                navigate('/desired-partner');
            }

        } catch (error) {
            console.log('Error While Posting Data:', error);
        }

    };

    if (isLoading) {
        return <div className='custom-loader-g'>
            <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    }

    // if (error) {
    //   return <div className="error">Error: {error}</div>;
    // }

    return (

        <>
            <div className='py-md-5'></div>

            <div className='create-profile-wrapper-container'  >
                <div className='create-profile-wrapper' >
                    <div className='container'>
                        <div className="create-profile-container">
                            {/* Left Side Form */}
                            <div className="create-profile-form-side">
                                <h1 className="create-profile-heading text-center">Create Your Account</h1>
                                {/* <p className="create-profile-subheading text-center">Start your journey here</p> */}

                                <form className="create-profile-form" onSubmit={handleSubmit}>
                                    {/* Section 1: Basic Details */}
                                    <h3 className="form-section-title text-center mb-0">Basic Details</h3>

                                    <div className="form-group">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            rows={6}
                                            className="form-textarea"
                                            name="description"
                                            placeholder="Write something about yourself..."
                                            value={formData.description}
                                            onChange={handleInputChange}
                                        />
                                        {errors.description && <span className="field-error" style={{
                                            color: 'red',
                                            fontSize: '12px'
                                        }}>{errors.description}</span>}

                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Sub Caste</label>
                                            <Select
                                                options={options?.subCaste?.map(caste => ({
                                                    label: caste,
                                                    value: caste
                                                }))}
                                                value={formData.subcaste}
                                                onChange={(selected) => handleSelectChange("subcaste", selected)}
                                                placeholder="Select Sub Caste"
                                                isDisabled={options.caste.length === 0}
                                            />
                                            {errors.subcaste && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.subcaste}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Current Location *</label>
                                            <Select
                                                options={options?.countries?.map(country => ({
                                                    label: Object.values(country).toString(),
                                                    value: (Object.keys(country).toString())
                                                }))}

                                                value={formData.currentlocation}
                                                onChange={(selected) => handleSelectChange("currentlocation", selected)}
                                                placeholder="Select Country"
                                                isDisabled={options.countries.length === 0}
                                            />
                                            {errors.currentlocation && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.currentlocation}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Manglik Dosha</label>

                                            <Select
                                                options={Array("Yes", "No").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.manglik}
                                                onChange={(selected) => handleSelectChange("manglik", selected)}
                                                placeholder="Select Maglik"

                                            />
                                            {errors.manglik && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.manglik}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Marital Status *</label>


                                            <Select
                                                options={Array("Single", "Divorce", "Widowed").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.maritalStatus}
                                                onChange={(selected) => handleSelectChange("maritalStatus", selected)}
                                                placeholder="Select Marital Status"

                                            />

                                            {errors.maritalStatus && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.maritalStatus}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Height (in feet) *</label>


                                            <Select
                                                options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                                                    .flatMap(feet =>
                                                        Array.from({ length: 12 }, (_, inches) => {
                                                            if (feet === 7 && inches > 0) return null;
                                                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                                                        }).filter(Boolean)
                                                    )}


                                                value={formData.height}

                                                onChange={(selected) => handleSelectChange("height", selected)}
                                                placeholder="Select Height"

                                            />
                                            {errors.height && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.height}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Weight (in Kg)</label>




                                            <Select
                                                options={[...Array.from({ length: 111 }, (_, i) => i + 40).map(val => ({ label: val + " Kg", value: val })), { label: `150+ Kg`, value: '150+' }]}

                                                value={formData.weight}
                                                onChange={(selected) => handleSelectChange("weight", selected)}
                                                placeholder="Select Weight"
                                            />

                                            {errors.weight && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.weight}</span>}
                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Body Type *</label>

                                            <Select
                                                options={Array("Slim", "Average", "Athletic", "Heavy").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.bodyType}
                                                onChange={(selected) => handleSelectChange("bodyType", selected)}
                                                placeholder="Select Body Type"
                                            />
                                            {errors.bodyType && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.bodyType}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Physical Status : *</label>


                                            <Select
                                                options={Array("Normal", "Physically Challenged").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.physicalStatus}
                                                onChange={(selected) => handleSelectChange("physicalStatus", selected)}
                                                placeholder="Select Physical Status"
                                            />
                                            {errors.physicalStatus && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.physicalStatus}</span>}

                                        </div>
                                    </div>


                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Eating Habits : </label>


                                            <Select
                                                options={Array("Vegetarian", "Non-Vegetarian", "Jain", "Eggetarian").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.eatingHabits}
                                                onChange={(selected) => handleSelectChange("eatingHabits", selected)}
                                                placeholder="Select Eating Habits"
                                            />
                                            {errors.eatingHabits && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.eatingHabits}</span>}



                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Drinking Habits : </label>


                                            <Select
                                                options={Array("Yes", "No", "Occasionally").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.drinkingHabits}
                                                onChange={(selected) => handleSelectChange("drinkingHabits", selected)}
                                                placeholder="Select Drinking Habits"
                                            />

                                            {errors.drinkingHabits && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.drinkingHabits}</span>}
                                        </div>

                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Smoking Habits : </label>


                                            <Select
                                                options={Array("Yes", "No", "Occasionally").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}

                                                value={formData.smokingHabits}
                                                onChange={(selected) => handleSelectChange("smokingHabits", selected)}
                                                placeholder="Select Smoking Habits"
                                            />

                                            {errors.smokingHabits && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.smokingHabits}</span>}

                                        </div>

                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Hobbies : </label>


                                            <Select
                                                options={[
                                                    {
                                                        label: "Creative & Artistic",
                                                        options: [
                                                            { value: "drawing", label: "Drawing" },
                                                            { value: "painting", label: "Painting" },
                                                            { value: "writing", label: "Writing" },
                                                            { value: "photography", label: "Photography" },
                                                            { value: "calligraphy", label: "Calligraphy" },
                                                            { value: "scrapbooking", label: "Scrapbooking" },
                                                            { value: "sewing", label: "Sewing" },
                                                            { value: "knitting", label: "Knitting" },
                                                            { value: "crocheting", label: "Crocheting" },
                                                            { value: "woodworking", label: "Woodworking" },
                                                            { value: "metalworking", label: "Metalworking" },
                                                            { value: "lego", label: "LEGO Building" },
                                                            { value: "model_building", label: "Model Building" },
                                                            { value: "home_decor", label: "Home Decor" },
                                                            { value: "interior_design", label: "Interior Design" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Performance & Entertainment",
                                                        options: [
                                                            { value: "dancing", label: "Dancing" },
                                                            { value: "singing", label: "Singing" },
                                                            { value: "playing_music", label: "Playing Musical Instruments" },
                                                            { value: "acting", label: "Acting" },
                                                            { value: "magic", label: "Magic Tricks" },
                                                            { value: "vlogging", label: "Vlogging" },
                                                            { value: "podcasting", label: "Podcasting" },
                                                            { value: "blogging", label: "Blogging" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Outdoor & Physical",
                                                        options: [
                                                            { value: "hiking", label: "Hiking" },
                                                            { value: "camping", label: "Camping" },
                                                            { value: "fishing", label: "Fishing" },
                                                            { value: "gardening", label: "Gardening" },
                                                            { value: "cycling", label: "Cycling" },
                                                            { value: "running", label: "Running" },
                                                            { value: "swimming", label: "Swimming" },
                                                            { value: "yoga", label: "Yoga" },
                                                            { value: "meditation", label: "Meditation" },
                                                            { value: "surfing", label: "Surfing" },
                                                            { value: "skateboarding", label: "Skateboarding" },
                                                            { value: "skiing", label: "Skiing" },
                                                            { value: "snowboarding", label: "Snowboarding" },
                                                            { value: "horseback_riding", label: "Horseback Riding" },
                                                            { value: "archery", label: "Archery" },
                                                            { value: "martial_arts", label: "Martial Arts" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Tech & Digital",
                                                        options: [
                                                            { value: "gaming", label: "Gaming" },
                                                            { value: "coding", label: "Coding" },
                                                            { value: "robotics", label: "Robotics" },
                                                            { value: "3d_printing", label: "3D Printing" },
                                                            { value: "investing", label: "Investing" },
                                                            { value: "language_learning", label: "Learning Languages" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Culinary",
                                                        options: [
                                                            { value: "cooking", label: "Cooking" },
                                                            { value: "baking", label: "Baking" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Mind & Collection",
                                                        options: [
                                                            { value: "reading", label: "Reading" },
                                                            { value: "puzzles", label: "Puzzles" },
                                                            { value: "board_games", label: "Board Games" },
                                                            { value: "collecting_stamps", label: "Stamp Collecting" },
                                                            { value: "collecting_coins", label: "Coin Collecting" },
                                                            { value: "birdwatching", label: "Birdwatching" },
                                                            { value: "bird_breeding", label: "Bird Breeding" },
                                                            { value: "geocaching", label: "Geocaching" },
                                                            { value: "astrology", label: "Astrology" },
                                                            { value: "astronomy", label: "Astronomy" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Media & Entertainment",
                                                        options: [
                                                            { value: "movies", label: "Watching Movies" },
                                                            { value: "tv_series", label: "Watching TV Series" },
                                                            { value: "anime", label: "Watching Anime" },
                                                            { value: "traveling", label: "Traveling" },
                                                        ],
                                                    },
                                                    {
                                                        label: "Community & Social",
                                                        options: [
                                                            { value: "volunteering", label: "Volunteering" },
                                                        ],
                                                    }
                                                ]}


                                                isMulti={true}
                                                value={formData.hobbies}
                                                onChange={(selected) => handleSelectChange("hobbies", selected)}
                                                placeholder="Select Hobbies"
                                            />


                                            {errors.hobbies && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.hobbies}</span>}


                                        </div>


                                    </div>


                                    {/* Section 2: Education & Career */}
                                    <h3 className="form-section-title text-center my-2">Education & Career</h3>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Highest Education *</label>

                                            <Select
                                                options={Array("Not Educated", "10th Pass", "12th Pass", "Diploma", "Graduate", "Post Graduate", "M Phil", "PHD", "Other").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.highestEducation}
                                                onChange={(selected) => handleSelectChange("highestEducation", selected)}
                                                placeholder="Select Highest Education"
                                            />


                                            {errors.highestEducation && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.highestEducation}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Education Qualification</label>

                                            <Select
                                                options={options?.education?.map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.educationQualification}
                                                onChange={(selected) => handleSelectChange("educationQualification", selected)}
                                                placeholder="Select Qualtification"
                                            />


                                            {errors.educationQualification && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.educationQualification}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Occupation *</label>

                                            <Select
                                                options={options?.occupation?.map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.occupation}
                                                onChange={(selected) => handleSelectChange("occupation", selected)}
                                                placeholder="Select Occupation"
                                            />


                                            {errors.occupation && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.occupation}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Employed In</label>

                                            <Select
                                                options={Array("Private Sector", "Government / Puboptionc Sector", "Civil Services", "Defence", "Self- Employed", "Unemployed").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.employedIn}
                                                onChange={(selected) => handleSelectChange("employedIn", selected)}
                                                placeholder="Select Employed In"
                                            />

                                            {errors.employedIn && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.employedIn}</span>}

                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Annual Income *</label>

                                            <Select
                                                options={options?.income?.map((val, index) => ({
                                                    label: val,
                                                    value: (index + 1)
                                                }))}
                                                value={formData.annualIncome}
                                                onChange={(selected) => handleSelectChange("annualIncome", selected)}
                                                placeholder="Select Income"
                                            />


                                            {errors.annualIncome && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.annualIncome}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Company Name</label>

                                            <input name="organizationName" className='form-control' onChange={handleInputChange} type='Text' />

                                        </div>
                                    </div>

                                    {/* Section 3: Family Details */}
                                    <h3 className="form-section-title text-center my-2">Family Details</h3>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Sister(s)</label>

                                            <Select
                                                options={Array(0, 1, 2, 3, "3+").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.sisters}
                                                onChange={(selected) => handleSelectChange("sisters", selected)}
                                                placeholder="Select Sister"
                                            />


                                            {errors.sisters && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.sisters}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Brother(s)</label>


                                            <Select
                                                options={Array(0, 1, 2, 3, "3+").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.brothers}
                                                onChange={(selected) => handleSelectChange("brothers", selected)}
                                                placeholder="Select Brother"
                                            />


                                            {errors.brothers && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.brothers}</span>}

                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Gothra</label>
                                            <Select
                                                options={options.gothra.map((k) => ({
                                                    label: Object.values(k),
                                                    value: Object.keys(k)
                                                }))}
                                                value={formData.gothra}
                                                onChange={(selected) => handleSelectChange("gothra", selected)}
                                                placeholder="Select Gothra"
                                                isDisabled={options.gothra.length === 0}
                                            />

                                            {errors.gothra && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.gothra}</span>}
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Gothra (Maternal)</label>
                                            <Select
                                                options={options.gothra.map((k) => ({
                                                    label: Object.values(k),
                                                    value: Object.keys(k)
                                                }))}
                                                value={formData.maternalGothra}
                                                onChange={(selected) => handleSelectChange("maternalGothra", selected)}
                                                placeholder="Select Maternal Gothra"
                                                isDisabled={options.gothra.length === 0}
                                            />


                                            {errors.maternalGothra && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.maternalGothra}</span>}
                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Family Status</label>


                                            <Select
                                                options={Array("Rich/Affluent", "Upper Middle", "Middle Class").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.familyStatus}
                                                onChange={(selected) => handleSelectChange("familyStatus", selected)}
                                                placeholder="Select Family Status"
                                            />

                                            {errors.familyStatus && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.familyStatus}</span>}

                                        </div>
                                        <div className="form-group">
                                            <label className="form-label">Family Type</label>

                                            <Select
                                                options={Array("Joint Family", "Nuclear Family").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.familyType}
                                                onChange={(selected) => handleSelectChange("familyType", selected)}
                                                placeholder="Select Family Type"
                                            />

                                            {errors.familyType && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.familyType}</span>}

                                        </div>
                                    </div>


                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Living with parents?</label>

                                            <Select
                                                options={Array("Yes", "No", "Not Applicable").map(val => ({
                                                    label: val,
                                                    value: val
                                                }))}
                                                value={formData.livingWithParents}
                                                onChange={(selected) => handleSelectChange("livingWithParents", selected)}
                                                placeholder="Select Living With Parents"
                                            />

                                            {errors.livingWithParents && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.livingWithParents}</span>}

                                        </div>


                                        <div className="form-group">
                                            <label className="form-label">Country</label>

                                            <Select
                                                options={options?.countries?.map(val => ({
                                                    label: Object.values(val).toString(),
                                                    value: (Object.keys(val)).toString()
                                                }))}
                                                value={formData.country}
                                                onChange={(selected) => handlecountryChange("country", selected)}
                                                placeholder="Select Country"
                                                defaultValue={{ label: "India", value: 101 }}
                                            />


                                            {errors.country && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.country}</span>}

                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="form-label">Family Belongs To (Native State) </label>
                                            <Select
                                                options={options?.states?.map(val => ({
                                                    label: Object.values(val).toString(),
                                                    value: Object.values(val).toString()
                                                }))}
                                                value={formData.familyBelongsTo}
                                                onChange={(selected) => handleSelectChange("familyBelongsTo", selected)}
                                                placeholder="Select Family Belongs To"

                                            />

                                            {errors.familyBelongsTo && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.familyBelongsTo}</span>}

                                        </div>


                                        <div className="form-group">
                                            <label className="form-label">Current State *</label>
                                            <Select
                                                options={options.states.map(state => ({
                                                    label: Object.values(state).toString(),
                                                    value: Object.keys(state).toString()
                                                }))}
                                                value={formData.state}
                                                onChange={(selected) => handleStateChange("state", selected)}
                                                placeholder="Select State"
                                                isDisabled={options.states.length === 0}
                                            />


                                            {errors.state && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.state}</span>}
                                        </div>

                                    </div>


                                    <div className="form-row">

                                        <div className="form-group">
                                            <label className="form-label">Current City</label>
                                            <Select
                                                options={options.cities.map(city => ({
                                                    label: city,
                                                    value: city
                                                }))}
                                                value={formData.city}
                                                onChange={(selected) => handleSelectChange("city", selected)}
                                                placeholder="Select City"
                                                isDisabled={options.cities.length === 0}
                                            />


                                            {errors.city && <span className="field-error"
                                                style={{ color: 'red', fontSize: '12px' }}>{errors.city}</span>}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Pin Code *</label>
                                            <input type='text' className='form-control' name='pincode' onChange={handleInputChange}
                                                value={formData.pincode} />

                                            {errors.pincode && <span className="field-error" style={{
                                                color: 'red',
                                                fontSize: '12px'
                                            }}>{errors.pincode}</span>}
                                        </div>


                                    </div>

                                    <button type="submit" className="create-btn mt-3">Submit</button>
                                </form>
                            </div>

                            {/* Right Side Image */}
                            <div className="create-profile-image-side d-none d-lg-block">
                                <img src={coupleImage} alt="Couple" className="couple-image" />
                                <div className="image-overlay">
                                    <h2 className="overlay-heading">
                                        Your Journey To Love Begins <span className="highlight">Here!</span>
                                    </h2>
                                    <p className="overlay-text">
                                        Connect With Genuine Matches Who Share Your <span
                                            className="highlight">Values</span> And <span className="highlight">Dreams</span>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <style>
                        {`


.create-profile-wrapper-container{
width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 20px;
}

.create-profile-wrapper{
width: 100%;
  max-width: 1200px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}



        /* Main Layout */

           .css-b62m3t-container{
margin-top:0 !important;
           }
        .form-group select,.form-group input
        {
        background:white;
        border-radius:15px;
        }
        .create-profile-wrapper {
        //   min-height: 100vh;
          background-color: #fff;
        }

        .create-profile-logo {
          max-width: 180px;
          margin: 20px;
        }

        .create-profile-container {
          display: flex;
          height: calc(100vh - 80px);
          overflow: hidden;
          padding:20px;
        }

        /* Form Side Styles */
        .create-profile-form-side {
          width: 60%;
          padding: 40px;
          overflow-y: auto;
          background-color: #fff;
        }

        .create-profile-heading {
          font-size: 2rem;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .create-profile-subheading {
          color: #666;
          margin-bottom: 0;
          font-size: 1rem;
        }

        .create-profile-form {
          display: flex;
          flex-direction: column;
          gap: 3px 1.5rem;
        }

        .form-section-title {
        
          color: #E53D5C;
          font-size: 1.3rem;
          font-weight: 600;
        }

        /* Form Elements */
        .form-group {
          display: flex;
          flex-direction: column;
          gap:3px  0.5rem;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 0.8rem;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E53D5C;
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
        }

        .form-row {
          display: flex;
          gap: 3px 1.5rem;
        }

        .form-row > .form-group {
          flex: 1;
        }

        /* Image Side Styles */
        .create-profile-image-side {
          width: 40%;
          position: relative;
          background-color: #F8E1E7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius:16px;
        }
        .create-profile-image-side img{
          border-radius:16px;
        }


        .couple-image {
          width: 100%;
          height:100%;
                        
        }

        .image-overlay {
          text-align: center;
          max-width: 100%;
          position: absolute;
          bottom: 40px;
          padding:20px;
        }
              
    
    
    
    
    

        .overlay-heading {
          font-size: 28.8px;
          color: white;
          
          line-height: 1.3;


                    
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: 12px;


        }

        .overlay-text {
          font-size: 1rem;
          color: #666;
          line-height: 1.6;
    
        color: white;
        font-weight: bold;


        }

        .highlight {
          color: #ffc107;
          font-weight: 600;
        }

        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          margin-top: 2rem;
        }

        .loading, .error {
          padding: 2rem;
          text-align: center;
          font-size: 1.2rem;
        }

        .error {
          color: #E53D5C;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .create-profile-container {
            flex-direction: column;
            height: auto;
            padding:0
          }
          
          .create-profile-form-side,
          .create-profile-image-side {
            width: 100%;
            padding:5px;
                    margin-top: 20px;
          }
          
          .form-row {
            flex-direction: column;
            gap: 3px 1rem;
          }
            .css-13cymwt-control {
            border-color: #dee2e6 !important ;
            }
          .css-13cymwt-control:hover {
            border-color: #dee2e6 !important ;
            }


            .create-profile-wrapper-container{
            padding-top:100px
            }


            .create-profile-form{
            gap:0 1.5rem
            }

            .form-group{
            gap:3px 0.5rem;
            }


        }
        `}
                    </style>
                </div>
            </div>

        </>
    );
};

export default CreateProfile;